import React, { useState, useEffect } from "react";
import styles from "./styles";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

let Carte = function Carte(props) {
  const [chefSuggestion, setChefSuggestion] = useState("");

  // Effectuer l'appel à l'API pour récupérer la suggestion du chef
  useEffect(() => {
    fetch("https://bbessere.lpmiaw.univ-lr.fr/resto/resto.php?getsuggestion=true")
      .then(response => response.text()) // On récupère la réponse comme une chaîne de texte
      .then(data => {
        setChefSuggestion(data); // On met à jour l'état avec la suggestion
      })
      .catch(error => console.error("Erreur lors de la récupération de la suggestion du chef :", error));
  }, []);

  console.log("Chargement du composant Carte");

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>La Carte</h1>
      
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h2>Pizza</h2>
        </AccordionSummary>
        <AccordionDetails>
          <table className="ui-responsive">
            <thead>
              <tr>
                <th>Nom</th>
                <th></th>
                <th>Recette</th>
                <th>Prix</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Marina</th>
                <td><img alt="Marina" src="./images/pizza1.jpg" width="100" /></td>
                <td>tomate, ail, origan, huile d'olive</td>
                <td>9 €</td>
              </tr>
              <tr>
                <th>Reine</th>
                <td><img alt="Reine" src="./images/reine.jpg" width="100" /></td>
                <td>tomate, mozzarella, jambon, champignon</td>
                <td>10 €</td>
              </tr>
              <tr>
                <th>Végétarienne</th>
                <td><img alt="Végétarienne" src="./images/veget.jpg" width="100" /></td>
                <td>tomate, artichauts, brocolis</td>
                <td>10 €</td>
              </tr>
            </tbody>
          </table>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h2>Pâtes</h2>
        </AccordionSummary>
        <AccordionDetails>
          <p>Vous pouvez inventer du contenu pour mettre ici, mais ce n'est pas nécessaire.</p>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h2>Desserts</h2>
        </AccordionSummary>
        <AccordionDetails>
          <p>Vous pouvez inventer du contenu pour mettre ici, mais ce n'est pas nécessaire.</p>
        </AccordionDetails>
      </Accordion>

      <Card style={{ margin: '2rem' }}>
        <CardContent sx={{ height: '100%' }}>
          <Typography variant="h5" component="div">
            Suggestion du chef : {chefSuggestion || "Chargement..."}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default Carte;
